import Swal from 'sweetalert2'
import BadgesModel from '../Apis/Badges'
import Users from '../Apis/Users'
import Controller from './Controller'

export default class BadgesController extends Controller {
  constructor() {
    super(new BadgesModel())
  }

  async allStudents(params) {
    // consu
    const data = new Users().students(params)
    return data
  }

  async badgeToStudents(recordIds, badgeId, re = '') {
    const params = {
      student_ids: recordIds,
      id: badgeId,
      type: re,
    }

    const res = await this.model.badgeToStudents(params);
    return this.Poup(res);

  }
}
